export default __webpack_public_path__ + "static/media/Kmptc.eeb5efe1.png";